import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetDetail} from '../../../../../../domain/widget/model/widget-detail';
import {Proposal, Tender, TenderStatus} from '../../../../../../domain/funding-tender/funding-tender-data';
import {Chart} from 'angular-highcharts';
import {WidgetSize} from 'src/app/domain/widget/model/widget-size.enum';
import {TranslateService} from '@ngx-translate/core';
import {DomainUrlService} from '../../../../../../application/config/domain-url.service';
import {UserContextService} from '../../../../../../application/app-context/user-context/user-context.service';
import {Duration} from '../../../../../../domain/shared/duration';

@Component({
  selector: 'app-widget-fundingtender',
  templateUrl: './home-dashboard-widget-fundingtender.component.html'
})
export class HomeDashboardWidgetFundingtenderComponent implements OnInit {

  @Input() widget: WidgetDetail;
  @Input() tender: Tender;
  TenderStatus = TenderStatus;

  @Output() actionEvent = new EventEmitter<string>();

  constructor(private translateService: TranslateService,
              private domainUrlService: DomainUrlService,
              private userContextService: UserContextService) {
  }

  ngOnInit(): void {
  }

  public trackAction(actionKey: string): void {
    this.actionEvent.emit(actionKey);
  }

  public goToFundingTenderDashboardPage(): string {
    let receiptPageUrl = this.domainUrlService.getFundingtenderUrl() + '/dashboard';
    const accountId = this.userContextService.getUserContext().accountId;
    receiptPageUrl += accountId != null ? '?accountId=' + accountId : '';
    return receiptPageUrl;
  }

}
